// extracted by mini-css-extract-plugin
export var box = "_5z-1";
export var checkboxRow = "_5z-8";
export var checked = "_5z-2";
export var descriptionSpacer = "_5z-a";
export var disabled = "_5z-3";
export var icon = "_5z-6";
export var input = "_5z-0";
export var labelSpacer = "_5z-9";
export var medium = "_5z-5";
export var small = "_5z-4";
export var text = "_5z-7";